import { FormikProvider, getIn, useFormik } from "formik";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { AppRoutes } from "../../../constants/appRoutes";
import { FormHelper } from "../../../helpers/formHelper";
import { buildRegionizeRoute } from "../../../helpers/regionRouteHelper";
import ActionBarDetail from "../../../shared/components/common/actionBarDetail";
import SectionWithHeading from "../../../shared/components/common/sectionWithHeading";
import { Spacing } from "../../../shared/components/common/spacing";
import InputWrapper from "../../../shared/formUtilities/useInput";
import { SMSNotificationService } from "../smsNotificationService";
import { Box } from "@mui/material";
import SelectWrapper from "../../../shared/formUtilities/useSelect";
import TextWrapper from "../../../shared/formUtilities/useTextWrapper";
import { MuiChipsInput } from "mui-chips-input";
import { SMSTemplateSchema } from "../../../shared/validations/schema";

export const SMSNotificationCreate = () => {
  const pushNotificationService = new SMSNotificationService();
  const id = useParams()?.id;
  const navigate = useNavigate();
  const [notification, setNotification] = useState({});
  const [loading, setLoading] = useState(false);
  const types = [{ name: "SMS", displayName: "SMS", id: 1 },{ name: "Push", displayName: "Push", id: 2 }];
  const initialValues = {
    name: '',
    variables: [],
    text: "",
    type: 1,
  };
  const form = useFormik({
    initialValues: initialValues,
    validationSchema: SMSTemplateSchema,
    onSubmit: () => {
      if (form.isValid) {
        onSaveOrUpdate();
      }
    },
    ...FormHelper.formikProps(),
  });

  let variables = getIn(form.values, 'variables');

  useEffect(() => {
    if (id) {
      setLoading(true);
      getNotificationById();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onAdd = (value) => {
    if (variables && variables?.length) {
      variables.push(value);
    } else {
      variables = [value];
    }
    form.setFieldValue('variables', variables);
  };

  const onDelete = (value) => {
    let emailVariable = variables.filter((resp) => resp !== value);
    form.setFieldValue('variables', emailVariable);
  };

  const getNotificationById = () => {
    pushNotificationService
      .getSMSNotificationDetail(id)
      .then((resp) => {
        setNotification(resp.data);
        form.setValues(resp.data);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const onEdit = (event) => {
    event.preventDefault();
    FormHelper.validateForm(form);
  };

  const onSaveOrUpdate = () => {
    setLoading(true);
    if (!id) {
      onSave();
    } else {
      onUpdate();
    }
  };

  const onNavigate = () => {
    navigate(buildRegionizeRoute(`${AppRoutes.SMSNotification}`));
  };

  const onSave = () => {
    pushNotificationService
      .addSMSNotification(form.values)
      .then((resp) => {
        setLoading(false);
        onNavigate();
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  const onUpdate = () => {
    pushNotificationService
      .updateSMSNotifications(id, form.values)
      .then((resp) => {
        setLoading(false);
        onNavigate();
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  return (
    <FormikProvider value={form}>
      <ActionBarDetail
        loading={loading}
        userName={`${notification?.name || 'Add Template'
          }`}></ActionBarDetail>
      <Spacing></Spacing>
      <SectionWithHeading
        loading={loading}
        heading={'SMS Notification Template'}
        isEditButton={true}
        onEditInfo={(e) => {
          onEdit(e);
        }}
        isEditToggle={true}
        children={
          <fieldset
            style={{ height: 'fit-content' }}>
            <Box className="grid grid-cols-2 gap-4">
              <InputWrapper
                name={'name'}
                key={'name'}
                label={'Template Name'}></InputWrapper>
              <SelectWrapper
                items={types}
                key={'type'}
                name={'type'}
                label={'Template Type'} />
              <InputWrapper
                rows={2}
                name={'text'}
                key={'text'}
                isTextArea
                label={'Text'}></InputWrapper>
              <Box className="flex flex-col justify-start items-start">
                <TextWrapper
                  type="caption"
                  text={'SMS Variables'}></TextWrapper>
                <MuiChipsInput
                  hideClearAll={true}
                  variant="outlined"
                  className="w-full"
                  value={variables}
                  onAddChip={(e) => {
                    onAdd(e);
                  }}
                  onDeleteChip={(value) => {
                    onDelete(value);
                  }}
                />
              </Box>
            </Box>
          </fieldset>
        }></SectionWithHeading>
    </FormikProvider>
  );

};